export default {
  listHeaders() {
    return [
      { text: 'Proje', value: 'proje' },
      { text: 'Malzeme', value: 'malzeme' },
      { text: 'Miktar', value: 'miktar' },
      { text: 'Birim', value: 'birim' },
      { text: 'Tür', value: 'tur' },
      { text: 'Sipariş No', value: 'siparisNo' },
      { text: 'Tutar', value: 'tutarr' },
    ];
  },
};
